<ion-content class="ion-padding">
  <ion-refresher slot="fixed" (ionRefresh)="buscarPagamentos($event)">
    <ion-refresher-content>
    </ion-refresher-content>
  </ion-refresher>

  <usucampeao-pagamentos-listagem [cadastro]="cadastro$ | async"
    [pagamentos]="pagamentos$ | async"></usucampeao-pagamentos-listagem>
</ion-content>
